<style scoped>
* {
  text-align: left;
}
.van-pull-refresh .van-cell:nth-child(odd) .containButton span {
  border: 1px solid #ea8d92;
  color: #ea8d92;
}
.van-cell {
  padding: 0;
  line-height: 16px;
}
.van-cell::after {
  border-bottom: none;
}
.homeLogo {
  width: 70%;
  display: block;
}
.van-cell {
  margin-bottom: 1.5rem;
}
.contain {
  width: 92%;
  margin: 0 auto;
}
.searchBox span {
  color: #2a2a2a;
  -webkit-box-align: center;
  -webkit-box-flex: 1;
  font-size: 1.34rem;
  line-height: 3.2rem;
  display: block;
}
.van-icon-search {
  float: left;
}
.searchBox {
  overflow: hidden;
  width: 93%;
  margin: 2rem auto 0;
  display: -webkit-box;
  -webkit-box-orient: horizontal;
}
.searchBox-left {
  display: -webkit-box;
  -webkit-box-orient: horizontal;
  -webkit-box-align: center;
  -webkit-box-flex: 1;
  border: 1px solid #e1e1e1;
  border-radius: 100px;
}
.van-icon-search {
  -webkit-box-align: center;
}
.searchBox-right {
  -webkit-box-align: center;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.searchBox-right b {
  float: left;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 3.2rem;
}
.navBox {
  overflow-x: auto;
  margin-top: 2rem;
}
.navBox ul{
  /* width: calc(100% * 6 / 4.5); */
}
.navBox li {
  /* width: calc(100% / 6); */
  width: 25%;
  display: inline-block;
  text-align: center;
}
.navBox li:nth-child(-n+4){
   margin-bottom: .7rem;
}
.navBox li img {
  width: 3.6rem;
  display: block;
  margin: 0 auto;
}
.navBox li span {
  font-size: 1.4rem;
  color: #060606;
  display: block;
  text-align: center;
  margin-top: 0.4rem;
}
.contain {
  margin-top: 3rem;
}
.containTitle {
  font-size: 1.8rem;
  color: #060606;
  text-align: left;
  margin-bottom: 1rem;
}
.van-cell__value {
  display: -webkit-box;
  -webkit-box-orient: horizontal;
}
.containImages {
  -webkit-box-align: center;
  width: 12.6rem;
  height: 8.4rem;
}
.containImages img {
  width: 100%;
  height: 100%;
}
.containContet {
  -webkit-box-align: center;
  -webkit-box-flex: 1;
  padding-left: 1rem;
  position: relative;
}
.containContet h3 {
  text-align: left;
  font-size: 1.4rem;
  font-weight: 400;
  color: #060606;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 0.5rem;
}
.containContet p {
  margin-bottom: 0.2rem;
}
.containContet p span {
  margin-right: 0.5rem;
  color: #7d7e7b;
  font-size: 1.1rem;
}
.van-button {
  font-size: 1rem;
  padding: 0 7px;
  height: 20px;
  line-height: 20px;
  margin-right: 6px;
}
.containButton {
  margin-top: 0.5rem;
}
.containButton span {
  border: 1px solid #ea8d92;
  border-radius: 2px;
  padding: 2px 5px;
  color: #ea8d92;
  margin-right: 0.5rem;
  font-size: 1rem;
  background: #fefffb;
}
.containButton span:last-child {
  margin-right: 0;
}
.containButton.bule span {
  border: 1px solid #9fbbd1;
  color: #3f7fbf;
  display: inline-block;
  margin-top: 0.3rem;
}
.prix {
  position: absolute;
  top: 2.4rem;
  right: 1rem;
  color: #d21b0d;
  font-size: 1.4rem;
}
.van-pull-refresh {
  min-height: 300px;
}

</style>
<template>
  <div class="home">
    <img src="../assets/images/logo.png" class="homeLogo" @click="backHome" />
    <div class="searchBox">
      <div class="searchBox-left" @click="toSearch">
        <van-icon
          class="searchIcon"
          name="search"
          style=" margin-top: 0.2rem; margin-right: 0.5rem; margin-left:.5rem"
          size="2.3rem"
          color="#c05456"
        />
        <span v-if="search">{{ search }}</span>
        <span v-else style="color: #888">输入区域、商圈、小区名</span>
      </div>
      <div class="searchBox-right">
        <img
          src="../assets/images/address.png"
          style="width: 2.5rem; float: left; margin-top: 0.2rem"
        />
        <b is-link @click="showPopup">{{ addressName }}</b>
        <van-popup v-model="show" position="bottom">
          <van-area title="请选择地区" :area-list="areaList" @confirm="confirm" @cancel="cancel" />
        </van-popup>
      </div>
    </div>

    <div class="navBox">
      <ul>
        <li @click="setCategory(1)">
          <img src="../assets/images/icon1.png" />
          <span>新房</span>
        </li>
        <li @click="setCategory(2)">
          <img src="../assets/images/icon2.png" />
          <span>二手房</span>
        </li>
        <li @click="setCategory(4)">
          <img src="../assets/images/icon4.png" />
          <span>买商铺</span> <!-- 原商铺-->
        </li>
        <li @click="setCategory(6)">
          <img src="../assets/images/icon6.png" />
          <span>买写字楼</span> <!-- 原写字楼-->
        </li>
         <li @click="setCategory(3)">
          <img src="../assets/images/icon3.png" />
          <span>租房</span>
        </li>
         <li @click="setCategory(7)">
          <img src="../assets/images/icon7.png" />
          <span>租商铺</span> 
        </li>
         <li @click="setCategory(8)">
          <img src="../assets/images/icon8.png" />
          <span>租写字楼</span> 
        </li>
         <li @click="setCategory(5)">
          <img src="../assets/images/icon5.png" />
          <span>其他</span>
        </li>
      </ul>
    </div>
    <van-pull-refresh v-model="pullDownLoading" @refresh="onRefresh">
      <div class="contain">
        <template v-if="!id">
          <h1 v-if="search" class="containTitle">搜索结果</h1>
          <h1 v-else class="containTitle">为您推荐</h1>
        </template>
        <template v-else>
          <h1 v-if="search" class="containTitle">{{ category[id] }}搜索结果</h1>
          <h1 v-else class="containTitle">{{ category[id] }}推荐</h1>
        </template>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <van-cell v-for="(item, index) in data" :key="index" v-on:click="about(item.ID)">
            <div class="containImages">
              <img :src="item.Images" />
            </div>
            <div class="containContet">
              <h3>{{ item.Title }}</h3>
              <div class="prix">{{ item.Price }}</div>
              <div class="containPag">
                <p>
                  <span>{{ item.Specs }}</span>
                  <span>{{ category[item.Category] }}</span>
                </p>
                <p>
                  <span>{{ item.Area }}平</span>
                  <span>{{ item.Direction }}</span>
                  <span>{{ item.FixLevel }}</span>
                </p>
                <div class="containButton bule" v-if="item.Tags.replace(/\s/g, '')">
                  <span v-for="(tag, tindex) in item.Tags.trim().split(/\s+/g)" :key="tindex" if>{{ tag }}</span>
                </div>
                <div class="containButton bule" v-else>&nbsp;</div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </div>
    </van-pull-refresh>
  </div>
</template>


<script>
import area from "../assets/area.js";
import apis from "@/apis.js";
import { Toast } from "vant";
export default {
  data() {
    return {
      areaList: area,
      show: false,
      loading: false,
      finished: false,
      pullDownLoading: false,
      data: [],
      category: ["-", "新房", "二手房", "租房", "商铺", "商业地产","写字楼"],
      paging: { size: 10, page: 1 },
    };
  },
  name: "Home",
  computed: {
    id: function () {
      return this.$route.query.id || 0; //类型
    },
    search: function () {
      return this.$route.query.search || ""; //搜索
    },
    areacode: function () {
      return this.$route.query.district || "";
    },
    addressName: function () {
      var area = require("../assets/area.js");
      area = area.default || area;
      if (this.$route.query.district && area && area.county_list) {
        return area.county_list[this.$route.query.district] || "地区";
      }
      return "地区";
    },
  },
  methods: {
    about: function (id) {
      this.$router.push({ name: "About", query: { id: id } });
    },
    showPopup: function () {
      this.show = true;
    },
    confirm: function (val) {
      var areacode = val[val.length - 1].code;
      this.show = false;
      var obj = Object.assign({}, this.$route.query);
      areacode ? (obj.district = areacode) : delete (obj, "district");
      this.$router.push({ name: "Home", query: obj });
      // this.onRefresh();
    },
    cancel: function () {
      this.show = false;
    },
    toSearch: function () {
      this.$router.push({ name: "Search" });
    },
    backHome: function () {
      this.$router.replace({ name: "Home", query: {} });
      // this.onRefresh();
    },
    setCategory: function (id) {
      var obj = Object.assign({}, this.$route.query);
      id ? (obj.id = id) : delete (obj, "id");
      this.$router.push({ name: "Home", query: obj });
      // this.onRefresh();
    },
    onRefresh: function () {
      this.data = [];
      this.paging.page = 1;
      this.pullDownLoading = false;
      this.onLoad();
    },
    onLoad: function () {
      this.finished = false;
      this.loading = true;
      var _this = this;
      apis
        .list({
          type: this.id,
          page: this.paging.page,
          size: this.paging.size,
          search: this.search,
          district: this.areacode,
        })
        .then(function (r) {
          _this.finished = r.total <= _this.paging.page++;
          r.data.forEach(function (item) {
            _this.data.push(item);
          });
        })
        .catch(function () {
          _this.finished = _this.finished = true;
        })
        .finally(function () {
          _this.loading = false;
        });
    },
  },
  watch: {
    "$route.query": "onRefresh",
  },
};
</script>
